import React, { useState } from 'react'
import { firestore } from '../../../../../firebase';

function SingleResultRound({result, roundId, hostcupId, draw, activeItem}) {

    const [homeGoals, setHomeGoals] = useState(result.home_goals);
    const [awayGoals, setAwayGoals] = useState(result.away_goals);
    const [homePoints, setHomePoints] = useState(result.home_points);
    const [awayPoints, setAwayPoints] = useState(result.away_points);

    const [homeName, setHomeName] = useState(result.home_team)
    const [awayName, setAwayName] = useState(result.away_team)



    const [error, setError] = useState("");
    const [message, setMessage] = useState("");

    async function editHandler(e) {

        e.preventDefault();
        try {
            const resultRef = firestore.collection("hostcup").doc(hostcupId).collection("rounds").doc(roundId).collection("results").doc(result.id);
            const data = {
                home_goals: +homeGoals,
                away_goals: +awayGoals,
                home_points: +homePoints,
                away_points: +awayPoints,
                home_team: homeName,
                away_team: awayName
            }
            resultRef.update(data);
            setMessage("Oppdatert");
        } catch (error) {
            setError("Kunne ikke oppdatere")
        }

    }
    async function deleteHandler(e, id) {
        e.preventDefault();
        try {
            const resultRef = firestore.collection("hostcup").doc(hostcupId).collection("rounds").doc(roundId).collection("results").doc(id);
            resultRef.delete();
        } catch (error) {
            setError("Kunne ikke slette")
        }
    }


    return (
        <React.Fragment>
            {activeItem === "1" && (
                <tr>
                    <td>
                        <input className="form-control" value={homeName} onChange={e => setHomeName(e.target.value)} />
                    </td>
                    <td>
                        <input type="number" className="form-control" value={homePoints} onChange={e => setHomePoints(e.target.value)} />
                    </td>
                    <td>
                        <input type="number" className="form-control" value={homeGoals} onChange={e => setHomeGoals(e.target.value)} />
                    </td>
                    <td>
                        <input type="number" className="form-control" value={awayGoals} onChange={e => setAwayGoals(e.target.value)} />
                    </td>
                    <td>
                        <input type="number" className="form-control" value={awayPoints} onChange={e => setAwayPoints(e.target.value)} />
                    </td>
                    <td>
                        <input className="form-control" value={awayName} onChange={e => setAwayName(e.target.value)} />
                    </td>
                    <td>
                        <button onClick={editHandler} className={`btn btn-sm btn-${message ? "success" : "primary"}`}>{message ? message : "Oppdater"}</button> 
                    </td>
                    <td>
                        <i onClick={(e) => deleteHandler(e, result.id)} className="fas fa-trash"></i>
                    </td>
                </tr>
            )}
            {activeItem === "2" && (
                <tr>
                    <td>T{draw}{homeName}</td>
                    <td>{homeGoals}</td>
                    <td>{awayGoals}</td>
                    <td>T{draw}{awayName}</td>
                    <td>{homePoints}</td>
                    <td>{awayPoints}</td>
                </tr>
            )}
        </React.Fragment>
    )

}
export default SingleResultRound